import { render } from "./cardAssignsByDayComponent.vue?vue&type=template&id=3878fc5a"
import script from "./cardAssignsByDayComponent.vue?vue&type=script&lang=js"
export * from "./cardAssignsByDayComponent.vue?vue&type=script&lang=js"

import "./cardAssignsByDayComponent.vue?vue&type=style&index=0&id=3878fc5a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__